import { NavLink } from "react-router-dom";
import BackArrow from "../assets/icons/back-arrow";
import "../assets/styles/components/back-arrow-button.scss";

export default function BackArrowButton({ state = null, path, func = null }) {
  return func ? (
    <div className="back-arrow-button position-fixed py-3 px-2" onClick={func}>
      <BackArrow color="#ffffff" size={25} />
    </div>
  ) : (
    <NavLink
      to={path}
      state={state}
      className="back-arrow-button position-fixed py-3 px-2"
    >
      <BackArrow color="#ffffff" size={25} />
    </NavLink>
  );
}
